export default __webpack_public_path__ + "static/perekrestok_vprok-fb72932053652081325761cba3d50e96.webp";